import { render } from "./Chars.vue?vue&type=template&id=3c2757c4&scoped=true"
import script from "./Chars.vue?vue&type=script&lang=js"
export * from "./Chars.vue?vue&type=script&lang=js"

import "./Chars.vue?vue&type=style&index=0&id=3c2757c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2757c4"]])

export default __exports__